@let isAdvancedOpen = advancedSearchOpen$ | async;

<div class="advanced-search-wrapper">
  <div class="advanced-search-input">
    @if (showSearchField) {
      <app-search-input
        [placeholder]="placeholder"
        [debounceTime]="debounceTime"
        [value]="value"
        [isAdvancedSearch]="true"
        [isDisabled]="isAdvancedOpen"
        [ngClass]="{ disabled: isAdvancedOpen }"
        (historyOpened)="handleHistoryOpened($event)"
        (inputChanged)="handleInputChange($event)"
        (focusin)="onFocusIn()"
      ></app-search-input>
    }

    @if (
      historyListOpen && filteredRecentSearches.length > 0 && !isAdvancedOpen
    ) {
      <div class="history-dropdown">
        @for (
          item of filteredRecentSearches;
          track trackByRecent(i, item);
          let i = $index
        ) {
          <div
            class="history-item"
            [class.active]="i === activeIndex"
            (mousedown)="handleHistoryItemClick(item, $event)"
            #historyItemRef
          >
            <span
              [innerHTML]="
                item.query_text | slice: 0 : 30 | highlight: currentQuery
              "
              [suiTooltip]="
                item.query_text.length >= 30 ? item.query_text : null
              "
            ></span>
            @if (item.query_text?.length > 30) {
              &hellip;
            }
            <!-- remove button -->
            <button
              type="button"
              class="remove-btn"
              [attr.aria-label]="
                'advanced-quick-search.tooltip.remove-recent-search' | translate
              "
              [suiTooltip]="
                'advanced-quick-search.tooltip.remove-recent-search' | translate
              "
              (mousedown)="removeRecent(item, $event)"
            >
              &times;
            </button>
          </div>
        }
      </div>
    }

    @if (showAdvancedToggle) {
      <div class="advanced-search-toggle">
        <sui-button
          variant="primary"
          size="sm"
          [leadingIcon]="
            !isAdvancedOpen
              ? ['fas', 'magnifying-glass-plus']
              : ['fas', 'magnifying-glass-minus']
          "
          [iconOnly]="true"
          [ariaLabel]="
            'advanced-search.button.advanced-search-toggle' | translate
          "
          [suiTooltip]="
            'advanced-search.button.advanced-search-toggle' | translate
          "
          (click)="handleAdvancedOpened($event)"
        ></sui-button>
      </div>
    }
  </div>
</div>
